import React from 'react';
import { connect } from 'react-redux';
import { IconButton } from '@fluentui/react';
import { setConsolidatedShowNotes } from '../../../../../store/actions';
class NotesCell extends React.Component {

    render() {
        const { setConsolidatedShowNotes, showNotes } = this.props;

        return (
            <IconButton
                iconProps={{ iconName: 'DietPlanNotebook' }}
                onClick={() => setConsolidatedShowNotes(!showNotes) }
            />
        )
    }
};

const mapStateToProps = state => ({
    showNotes: state.consolidated.showNotes
})


const mapDispatchToProps = dispatch => ({
    setConsolidatedShowNotes: (i) => dispatch(setConsolidatedShowNotes(i))
})


export default connect(mapStateToProps, mapDispatchToProps)(NotesCell);
